import { useState } from 'react';
import ChargerModule from '../../components/chargerModule';
import DashboardTabs from './components/DashboardTabs/DashboardTabs';
import Tab1Mentions from './components/DashboardTabs/Tab1Mentions/Tab1Mentions';
import Tab2AgentChat from './components/DashboardTabs/Tab2AgentChat/Tab2AgentChat';
import { isModuleActive } from '../LogisticServices/utils/general.utils';
import { BACKOFFICE_MODULES } from '../../types/configuration.types';
import './dashboard.scss';

const Dashboard = () => {
  const [selectedTabId, setSelectedTabId] = useState<number>(0);
  const showAgentChat = isModuleActive(BACKOFFICE_MODULES.AI_CHAT);

  const headerInfo = {
    title: 'Dashboard',
    subtitle: '',
    headerNote: 'Organiza tu trabajo diario'
  };

  const infoSideBar = { position: 'dashboard' };

  const tabsList = [
    { tabId: 0, tabName: 'Menciones', component: <Tab1Mentions /> },
    ...(showAgentChat ? [{ tabId: 1, tabName: 'Pregunta a Bordi', component: <Tab2AgentChat /> }] : [])
  ];

  const currentTabComponent = tabsList[selectedTabId].component;

  if (!currentTabComponent) return null;
  return (
    <ChargerModule headerInfo={headerInfo} infoSideBar={infoSideBar}>
      <div className="dashboard">
        <DashboardTabs tabsList={tabsList} selectedTabId={selectedTabId} handleChangeSelectedTabId={setSelectedTabId} />
        {currentTabComponent}
      </div>
    </ChargerModule>
  );
};

export default Dashboard;
